import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CtrlHandleItemIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.687 16H2.31201C1.96683 16 1.68701 16.2798 1.68701 16.625V17.625C1.68701 17.9702 1.96683 18.25 2.31201 18.25H21.687C22.0322 18.25 22.312 17.9702 22.312 17.625V16.625C22.312 16.2798 22.0322 16 21.687 16Z"
        fill={color}
      />
      <path
        d="M21.687 5.75H2.31201C1.96683 5.75 1.68701 6.02982 1.68701 6.375V7.375C1.68701 7.72018 1.96683 8 2.31201 8H21.687C22.0322 8 22.312 7.72018 22.312 7.375V6.375C22.312 6.02982 22.0322 5.75 21.687 5.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

CtrlHandleItemIcon.displayName = 'CtrlHandleItemIcon';
